import React from 'react';

const BuilderMask = () => <div className="builder__blocks_mask" />;

export default BuilderMask;
